import { Pipe, PipeTransform } from '@angular/core';
import { roundToNearestFiveCents } from '../functions/round-to-nearest-five-cents';

@Pipe({
  name: 'roundToNearestFiveCents',
  standalone: true,
})
export class RoundToNearestFiveCentsPipe implements PipeTransform {
  transform(value: number | null | undefined): number {
    if (value == null) return 0;
    return roundToNearestFiveCents(value);
  }
}
